import { useRef, useState } from "react";
import { LIMIT_TEXT_REPORT } from "../../../utils/vars";
import Spinner from "../../../global-components/src/components/spinner/spiner";
import axios from "axios";
import { useMessage } from "../../../global-components/src";
import { useAuth } from "../../../global-components/src";
import { PACOCA_API_URL } from "../../../global-components/src/utils/vars";
import "./style.css";
import { ArrowLeft, X } from "lucide-react";
import { errorMessage } from "../../../global-components/src/utils/text";
import { useTranslation } from "react-i18next";

interface ReportModalProps {
    id_user: number | null;
    id_post?: number | null;
    onUpdateReportStatus?: (id_post: number, wasReported: boolean) => void;
}

const ReportModal: React.FC<ReportModalProps> = ({ id_user, id_post, onUpdateReportStatus }) => {
    const [text, setText] = useState("");
    const [isLimitExceeded, setIsLimitExceeded] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");
    const [typeReason, setTypeReason] = useState<number | null>(null);
    const { setMessage } = useMessage();
    const { token } = useAuth();
    const { t } = useTranslation();
    const closeRef = useRef<HTMLButtonElement | null>(null);
    const [errorsInput, setErrorsInput] = useState<any>({});

     const limitePost = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        const newText = event.target.value;
        setText(newText);
        setIsLimitExceeded(newText.length > LIMIT_TEXT_REPORT);
    }

    const handleReport = async () =>{
        setError("")
        setIsLoading(true)
        const url = PACOCA_API_URL + `/users/report/${id_user}`;
        
        try {
            let errors: Record<string, string[]> = {};

            if(!text){
                errors.reason = [t("errors.input.required", { field: t("generics.message") })]
            }

            if(text.length <=2){
                errors.reason = [t("errors.input.minLength", { field: t("generics.message"), min: 3 })]
            }

            if (Object.keys(errors).length > 0) {
                throw {
                    response: {
                        data: {
                            errors
                        }
                    }
                };
            }

            if(onUpdateReportStatus)
                onUpdateReportStatus?.(id_post || 0, true); // após denunciar
            
            await axios.post(url, {id_post, id_user, reason: text}, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });

            if(closeRef.current)
                closeRef.current.click()

            setText("")
            setMessage(t("report.success"), "success");
            setErrorsInput(""); 
        } catch (err: any) {
            if (err?.response?.data.errors) {
                setErrorsInput(err.response.data.errors); // Atualiza o estado com os erros
            } else {
                const messageError = errorMessage(err);
                setMessage(messageError, "error");
                console.error("Erro banir usuário: ", messageError);
                console.error("Erro banir usuário: ", err);
            }
        } finally{
            setIsLoading(false)
        }
    }
    
    return (
        <div className="modal fade" id="report-user" tabIndex={-1} aria-labelledby="modal-denunciar-usaurio" aria-hidden="true">
            <div className="modal-dialog cover-mobile">
                <form action="/user/report" method="post" id='form-report-user'>
                    <div className="modal-content">
                        <div className="modal-header">
                            {/* {window.innerWidth > 850 && !typeReason && (
                                <h5 className="modal-title" id="modal-denunciar-usaurio">Motivo da denúncia</h5>
                            )} */}
                            {typeReason && <ArrowLeft style={{ cursor: "pointer", opacity: .6, left: 10, marginRight: 5, top: 10, position: "absolute", zIndex: 2 }} onClick={() => {setTypeReason(null); setText("")}}/>}
                            {/* <button ref={closeRef} type="button" className="btn-close cancel-denuncia" data-bs-dismiss="modal" aria-label="Close"></button> */}
                            
                            <span ref={closeRef} style={{ cursor: "pointer", right: 10, marginRight: 5, top: 10, position: "absolute", zIndex: 2 }} data-bs-dismiss="modal" aria-label="Close" className="d-flex align-items-center svg-icons-color btn-dark">
                                <X opacity={.6}/>
                            </span>
                        </div>
                        <div className="modal-body modal-report-user user-select-none">
                                <h5 className="text-center text-mutted" style={{opacity: .7, marginTop: "10px"}}>{t("report.title")}</h5>
                                            <p className="text-center text-mutted" style={{opacity: .7}}>{t("report.anonymous")}</p>
                
                
                                            <div className="reason-report" style={{ display: typeReason && typeReason !== 1 ? "none" : "flex" }} onClick={() => { setTypeReason(1); setText(t("report.reasons.dontLike")) }}>
                                                {t("report.reasons.dontLike")}
                                            </div>
                                            
                                            <div className="reason-report" style={{ display: typeReason && typeReason !== 2 ? "none" : "flex" }} onClick={() => { setTypeReason(2); setText(t("report.reasons.bullying")) }}>
                                                {t("report.reasons.bullying")}
                                            </div>
                                            
                                            <div className="reason-report" style={{ display: typeReason && typeReason !== 3 ? "none" : "flex" }} onClick={() => { setTypeReason(3); setText(t("report.reasons.suicide")) }}>
                                                {t("report.reasons.suicide")}
                                            </div>
                                            
                                            <div className="reason-report" style={{ display: typeReason && typeReason !== 4 ? "none" : "flex" }} onClick={() => { setTypeReason(4); setText(t("report.reasons.violence")) }}>
                                                {t("report.reasons.violence")}
                                            </div>
                                            
                                            <div className="reason-report" style={{ display: typeReason && typeReason !== 5 ? "none" : "flex" }} onClick={() => { setTypeReason(5); setText(t("report.reasons.restricted")) }}>
                                                {t("report.reasons.restricted")}
                                            </div>
                            
                            <div className="reason-report" style={{ display: typeReason && typeReason !== 6 ? "none" : "flex" }} onClick={() => { setTypeReason(6); setText("Nudez ou atividade sexual") }}>
                                Nudez ou atividade sexual 
                            </div>
                            
                            <div className="reason-report" style={{ display: typeReason && typeReason !== 7 ? "none" : "flex" }} onClick={() => { setTypeReason(7); setText("Golpe, spam ou fraude") }}>
                                Golpe, spam ou fraude 
                            </div>
                            
                            <div className="reason-report" style={{ display: typeReason && typeReason !== 8 ? "none" : "flex" }} onClick={() => { setTypeReason(8); setText(t("report.reasons.falseInfo")) }}>
                                {t("report.reasons.falseInfo")}
                            </div>
                            
                            <div className="reason-report" style={{ display: typeReason && typeReason !== 9 ? "none" : "flex" }} onClick={() => { setTypeReason(9); setText("Propriedade intelectual") }}>
                                Propriedade intelectual 
                            </div>
                            
                            <div className="reason-report" style={{ display: typeReason && typeReason !== null ? "none" : "flex" }} onClick={() => { setTypeReason(10); }}>
                                Outro 
                            </div>
                            
                            <div className="col p-2">
                                {typeReason == 10 && (
                                <>
                                    <textarea 
                                        placeholder="Motivo da denuncia"
                                        value={text} 
                                        onChange={(e) => limitePost(e)} 
                                        className={`${errorsInput.reason ? 'is-invalid' : ''} form-control`} 
                                        name="text"
                                        style={{ color: isLimitExceeded ? "red" : "inherit" }} 
                                        cols={30} rows={10}/>

                                    {errorsInput.reason && (
                                        <div className="invalid-feedback" style={{display: "block"}}>{errorsInput.reason[0]}</div> // Exibe a mensagem de erro
                                    )}

                                    <div className="invalid-feedback invalid-feedback-comment-text" style={{display: "block"}}>
                                        {error}
                                    </div>
                                    
                                    <div className="user-select-none limite-denuncia">
                                        {text.length}/{LIMIT_TEXT_REPORT}
                                    </div>
                                </>
                            )}
                            
                            <div className="invalid-feedback invalid-feedback-report" style={{display: "block"}}>
                            </div>

                            <input type="hidden" name="user_denuncia_id" id="user_denuncia_id" value=""/>
                            </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary cancel-denuncia" data-bs-dismiss="modal">{t("generics.cancel")}</button>
                            {typeReason && (
                                <button disabled={isLoading || isLimitExceeded} type="button" className="btn btn-blue" onClick={handleReport}>
                                    {!isLoading ? (
                                        <>{t("post.actions.report")}</>
                                    ) : (
                                        <Spinner/>
                                    )}
                                </button>       
                            )}                 
                        </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ReportModal;
